import { CompteDetention } from 'src/app/api/model/compte-detention.model';
import { Telephones } from 'src/app/api/model/telephones.model';
import { TypeChangementEnum } from '../../constantes/type-changement.enum';

export class StateValidation {
  private constructor(
    public readonly type: string,
    public readonly compteDetention?: CompteDetention,
    public readonly comptesDetentionInitial?: CompteDetention[],
    public readonly telephones?: Telephones[]
  ) {}
  public static coordonnees(): StateValidation {
    return new StateValidation(TypeChangementEnum.COORDONNEES);
  }
  public static courriel(
    compteDetention?: CompteDetention,
    comptesDetentionInitial?: CompteDetention[]
  ): StateValidation {
    return new StateValidation(TypeChangementEnum.COURRIEL, compteDetention, comptesDetentionInitial);
  }
  public static telephone(telephones?: Telephones[]): StateValidation {
    return new StateValidation(TypeChangementEnum.TELEPHONE, undefined, undefined, telephones);
  }
}
